/**
 * Какие экшены попадают в запись локального матча и в каком виде.
 *
 * Правило то же, что у записи обучения и сетевого матча: пишется экшен,
 * изменивший ОБЩЕЕ состояние партии (state.shared). Так в запись попадают и
 * игровые действия, и служебные LOAD_STATE/SET_PLAYERS/SET_POLICY_MARKET/
 * START_GAME с noServerSync, а модалки и тосты, которые при просмотре
 * порождаются заново, — нет.
 *
 * В отличие от обучения, метки «на что игрок смотрел» (выбор отряда, карточки
 * фракций, правила) НЕ пишутся: в локальной партии игрок сидит сам с собой,
 * разбирать по ним нечего, а запись от них заметно толстеет.
 */

export const LOCAL_RUN_MARKER_TYPES = Object.freeze({
  RUN_LEFT: 'LOCAL_RUN_LEFT',
});

// Не пишутся никогда — тот же список, что у обучения и у сетевой записи.
// RESET_STATE — выход из партии, запись на нем заканчивается
export const LOCAL_RUN_NON_RECORDED_ACTION_TYPES = new Set([
  'SET_SELECTED_TOKEN',
  'SET_BOT_CONTROLLER',
  'RESET_STATE',
  // Флаг модалки улучшения живет в общем состоянии, но это чистый интерфейс:
  // открытая при просмотре модалка дала бы зрителю улучшить отряд в записи
  'SHOW_UNIT_UPGRADE_MODAL',
  'HIDE_UNIT_UPGRADE_MODAL',
]);

/**
 * Запись одного примененного экшена или null, если он в запись не идет
 *
 * @param {Object} action
 * @param {Object} options
 * @param {boolean} options.isSharedStateChanged - экшен изменил state.shared
 * @param {number} options.recordedAt - момент применения (мс), для разбора пауз
 * @returns {Object|null}
 */
export const buildLocalRunRecord = (action, {isSharedStateChanged, recordedAt}) => {
  if (!action || typeof action.type !== 'string' || LOCAL_RUN_NON_RECORDED_ACTION_TYPES.has(action.type)) {
    return null;
  }
  if (!isSharedStateChanged) {
    return null;
  }
  // Экшен целиком, со всеми флагами — как в сетевой записи
  return {...action, recordedAt};
};

/**
 * Метка выхода из локальной партии: раунд, на котором игрок ушел. Редьюсера у
 * нее нет — при просмотре она ничего не меняет
 */
export const buildLocalRunLeftRecord = ({round, recordedAt}) => ({
  type: LOCAL_RUN_MARKER_TYPES.RUN_LEFT,
  payload: {round: Number.isInteger(round) ? round : null},
  noServerSync: true,
  recordedAt,
});

/**
 * Прогресс локальной партии для карточки матча в истории: до какого раунда
 * запись дошла. Его показывает плашка незавершенного матча
 */
export const buildLocalRunProgress = ({round}) => ({
  round: Number.isInteger(round) ? round : 0,
});
